import {
  SavedMatchCriteriaItem,
  SavedPairCriteria,
  isDefined,
  scalarToNumber,
} from '@aloft/toolkit-shared';

import { DifferenceCriteria, MatchCriteria, MatchCriteriaItem } from '../matching/types.ts';

const convertMatchCriteriaItem = (
  saved?: SavedMatchCriteriaItem,
): MatchCriteriaItem | undefined => {
  if (!saved) return saved;

  switch (saved.t) {
    case 'any':
    case 'equal':
      return { ...saved };
    case 'greater':
    case 'less':
    case 'withinPercent':
    case 'withinUnit':
      return { t: saved.t, value: scalarToNumber(saved.value) };
    default:
      return undefined;
  }
};

export const savedCriteriaToWorkerInput = (
  savedPairCriteria: SavedPairCriteria,
): {
  matchCriteria: MatchCriteria;
  differenceCriteria: DifferenceCriteria;
} => {
  const { matchCriteria: savedMatchCriteria, differenceCriteria } = savedPairCriteria;

  // Convert to number for each of the matchCriteria
  const matchCriteria: MatchCriteria = {};

  if (isDefined(savedMatchCriteria.propertyType)) {
    matchCriteria.propertyType = convertMatchCriteriaItem(savedMatchCriteria.propertyType);
  }
  if (isDefined(savedMatchCriteria.propertySubType)) {
    matchCriteria.propertySubType = convertMatchCriteriaItem(savedMatchCriteria.propertySubType);
  }
  if (isDefined(savedMatchCriteria.coords)) {
    matchCriteria.coords = convertMatchCriteriaItem(savedMatchCriteria.coords);
  }
  if (isDefined(savedMatchCriteria.marketingCommentary)) {
    matchCriteria.marketingCommentary = convertMatchCriteriaItem(
      savedMatchCriteria.marketingCommentary,
    );
  }
  if (isDefined(savedMatchCriteria.address)) {
    matchCriteria.address = convertMatchCriteriaItem(savedMatchCriteria.address);
  }
  if (isDefined(savedMatchCriteria.zipCode)) {
    matchCriteria.zipCode = convertMatchCriteriaItem(savedMatchCriteria.zipCode);
  }
  if (isDefined(savedMatchCriteria.view)) {
    matchCriteria.view = convertMatchCriteriaItem(savedMatchCriteria.view);
  }
  if (isDefined(savedMatchCriteria.designStyle)) {
    matchCriteria.designStyle = convertMatchCriteriaItem(savedMatchCriteria.designStyle);
  }
  if (isDefined(savedMatchCriteria.heatingCooling)) {
    matchCriteria.heatingCooling = convertMatchCriteriaItem(savedMatchCriteria.heatingCooling);
  }
  if (isDefined(savedMatchCriteria.hasBasement)) {
    matchCriteria.hasBasement = convertMatchCriteriaItem(savedMatchCriteria.hasBasement);
  }
  if (isDefined(savedMatchCriteria.bedrooms)) {
    matchCriteria.bedrooms = convertMatchCriteriaItem(savedMatchCriteria.bedrooms);
  }
  if (isDefined(savedMatchCriteria.bathrooms)) {
    matchCriteria.bathrooms = convertMatchCriteriaItem(savedMatchCriteria.bathrooms);
  }
  if (isDefined(savedMatchCriteria.threeQuarterBathrooms)) {
    matchCriteria.threeQuarterBathrooms = convertMatchCriteriaItem(
      savedMatchCriteria.threeQuarterBathrooms,
    );
  }
  if (isDefined(savedMatchCriteria.halfBathrooms)) {
    matchCriteria.halfBathrooms = convertMatchCriteriaItem(savedMatchCriteria.halfBathrooms);
  }
  if (isDefined(savedMatchCriteria.totalBathrooms)) {
    matchCriteria.totalBathrooms = convertMatchCriteriaItem(savedMatchCriteria.totalBathrooms);
  }
  if (isDefined(savedMatchCriteria.stories)) {
    matchCriteria.stories = convertMatchCriteriaItem(savedMatchCriteria.stories);
  }
  if (isDefined(savedMatchCriteria.attachedGarageParkingSpacesCount)) {
    matchCriteria.attachedGarageParkingSpacesCount = convertMatchCriteriaItem(
      savedMatchCriteria.attachedGarageParkingSpacesCount,
    );
  }
  if (isDefined(savedMatchCriteria.glaSqFt)) {
    matchCriteria.glaSqFt = convertMatchCriteriaItem(savedMatchCriteria.glaSqFt);
  }
  if (isDefined(savedMatchCriteria.basementSqFt)) {
    matchCriteria.basementSqFt = convertMatchCriteriaItem(savedMatchCriteria.basementSqFt);
  }
  if (isDefined(savedMatchCriteria.siteSizeSqFt)) {
    matchCriteria.siteSizeSqFt = convertMatchCriteriaItem(savedMatchCriteria.siteSizeSqFt);
  }
  if (isDefined(savedMatchCriteria.yearBuilt)) {
    matchCriteria.yearBuilt = convertMatchCriteriaItem(savedMatchCriteria.yearBuilt);
  }
  if (isDefined(savedMatchCriteria.contractDate)) {
    matchCriteria.contractDate = convertMatchCriteriaItem(savedMatchCriteria.contractDate);
  }
  if (isDefined(savedMatchCriteria.saleDate)) {
    matchCriteria.saleDate = convertMatchCriteriaItem(savedMatchCriteria.saleDate);
  }
  if (isDefined(savedMatchCriteria.salePrice)) {
    matchCriteria.salePrice = convertMatchCriteriaItem(savedMatchCriteria.salePrice);
  }
  if (isDefined(savedMatchCriteria.hasBasement)) {
    matchCriteria.hasBasement = convertMatchCriteriaItem(savedMatchCriteria.hasBasement);
  }
  if (isDefined(savedMatchCriteria.hasAttachment)) {
    matchCriteria.hasAttachment = convertMatchCriteriaItem(savedMatchCriteria.hasAttachment);
  }

  // 1 to 1 for now (v1)
  return { matchCriteria, differenceCriteria };
};
